import { render, staticRenderFns } from "./PercursoUfDetalhes.vue?vue&type=template&id=2b38ff28"
import script from "./PercursoUfDetalhes.vue?vue&type=script&lang=js"
export * from "./PercursoUfDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports